import { i18n } from 'fishx';
import { message } from '@whalecloud/fdx';
import { delay } from 'redux-saga';
import get from 'lodash/get';
import { login, logout, changeUserPwd, qryCurrentSecurityRule, getInterval, getRemainingTime, getNoticeTime, recoverSession } from '@/services/api';
import { sendVerifyCode, preLogin, qryAllowMultipleTabPage, genCaptcha, doForgetPwdBsnl, sendSmsForgetPwdBsnl } from '@/services/bsnlLogin';
import { getPageQuery, setCookie, getCookie } from '@/utils/utils';
import { getRequestData, failAlert, tokenCountDown } from '@/utils';


export default {
  namespace: 'bsnlLogin',
  state: {
    isSuccess: undefined,
    resetModal: false,
    forgotModal: false,
    securityRule: {},
    userMsg: {
      userCode: '',
    },
    userInfo: {
      envId: 1001,
      userId: 1001,
      userName: 'react',
      userCode: 'react',
    },
    veriyfyConfig: {},
    sendTime: 0, // 验证码发送时的时间戳
    times: null, // 当前倒计时
    timing: false, // 倒计时中
    logining: false, // 登陆中
    lockOpen: false, // 打开两个页面锁页面
    imgReturn: {}, // 图形验证码返回
    forgotSendTime: 0, // 忘记密码验证码发送时的时间戳
    forgotTimes: null, // 忘记密码当前倒计时
    forgotTiming: false, // 忘记密码倒计时中
  },

  effects: {
    *preLogin({ payload }, { call, put }) {
      yield put({ type: 'save', payload: { logining: true } });
      const { success, data } = yield call(preLogin, payload);
      if (success) {
        const STAFF_ERROR_MAP = [
          { code: '0', message: '' }, // 是drm用户
          { code: '1', message: i18n('STAFF_IS_NOT_EXIST') },
          { code: '2', message: i18n('STAFF_DOES_NOT_HAVE_PERMISSION_TO_LOGIN') },
          { code: '3', message: i18n('STAFF_IS_ON_A_BLACKLIST') },
          { code: '4', message: i18n('STAFF_IS_ON_A_BLACKLIST_ORGANIZATION') },
        ];
        const { retCode } = data;
        STAFF_ERROR_MAP.forEach(item => {
          if ((retCode === item.code) && item.message) {
            message.error(item.message);
          }
        });
        if (retCode === STAFF_ERROR_MAP[0].code) {
          return true;
        }
        return false;
      }
      return false;
    },

    *login({ payload }, { call, put }) {
      const { success, errorMsg, data } = yield call(login, payload);
      const { isSuccess, ...rest } = data;
      if (success) {
        if (isSuccess && isSuccess === 1) {
          yield put({
            type: 'changeLoginStatus',
            payload: data,
          });
          const { redirect } = getPageQuery();
          let redirectUrl = redirect;
          // string 类型
          if (typeof redirect === 'string') {
            const hash = new URL(window.location.href);
            if (hash) {
              redirectUrl = redirect.replace(/#\//, '/');
            } else {
              redirectUrl = redirect.replace(/\/portal\//, '/');
            }
          }
          yield put({
            type: 'dxpGlobal/logged',
            payload: {
              from: 'Login',
              password: payload.password,
              redirect: redirectUrl,
            },
          });
          tokenCountDown();
        }
      } else if (data.code === 'POT-ACCOUNT-00007' || data.code === 'POT-LOGIN-00014' || data.code === 'POT-LOGIN-00020') {
        // 2021-07-21 交付测试的portal会有POT-LOGIN-00020这个code，报错提示首次登陆，要修改密码登陆
        // 默认密码和密码安全等级低时
        message.warning(`${data.message}${i18n('CHANGE_PWD_MSG')}`);

        // 首次登录 重置密码
        // 不符合安全规则 重置密码
        yield put({
          type: 'qryCurrentSecurityRule',
          payload,
        });
      } else if (data.code) {
        message.warning(`${data.message}`);
        // 2892588 密码失效重置密码
        if (data.code === 'POT-ACCOUNT-00005') {
          yield put({
            type: 'save',
            payload: {
              resetModal: true,
              userMsg: payload,
            },
          });
        }
      } else throw errorMsg;
      return rest;
    },


    *changeUserPwd({ payload }, { call, put, select }) {
      const { success } = yield call(changeUserPwd, payload);
      if (success) {
        message.success(i18n('CHANGE_PWD_SUCCESS'));
        yield put({
          type: 'save',
          payload: {
            resetModal: false,
          },
        });
        const { userMsg } = yield select(state => state.bsnlLogin);
        yield put({
          type: 'login',
          payload: {
            username: userMsg.username,
            password: payload.newPwd,
          },
        });
      } else {
        message.warning(i18n('CHANGE_PWD_FAILED'));
      }
    },

    *sendVerifyCode({ payload }, { call, put, select }) {
      const sendTime = yield select(state => state.bsnlLogin.sendTime);
      const times = yield select(state => state.business.DRM_BSNL_CAPTCHA_EXPIRE_CONFIG || 60);
      if (Date.now() - sendTime < times * 1000) {
        message.warn(i18n('BUSINESS_TOO_OFTEN'));
        return false;
      }
      const { success, data } = yield call(sendVerifyCode, payload);
      if (success && get(data, 'message') === 'success') {
        yield put({
          type: 'timing',
        });
        yield put({
          type: 'save',
          payload: { sendTime: Date.now() },
        });
        return true;
      }
      return false;
    },

    *timing(_, { put, select, cancel }) { // 验证码的倒计时
      let times = yield select(state => state.business.DRM_BSNL_CAPTCHA_EXPIRE_CONFIG || 60);
      yield put({
        type: 'save',
        payload: { timing: true, times },
      });
      for (; times >= 0; times -= 1) {
        const timing = yield select(state => state.bsnlLogin.timing);
        if (!timing) { // 如果循环还未完成，timing就被置为false了，说明当前循环需要跳出,同时取消当前的这个任务
          yield cancel();
          break;
        }
        yield put({
          type: 'save',
          payload: { times },
        });
        yield delay(1000);
      }
      yield put({
        type: 'save',
        payload: { timing: false, times },
      });
    },

    *sendSmsForgetPwdBsnl({ payload }, { call, put, select }) {
      const forgotSendTime = yield select(state => state.bsnlLogin.forgotSendTime);
      const times = yield select(state => state.business.DRM_BSNL_CAPTCHA_EXPIRE_CONFIG || 60);
      if (Date.now() - forgotSendTime < times * 1000) {
        message.warn(i18n('BUSINESS_TOO_OFTEN'));
        return false;
      }
      const response = yield call(sendSmsForgetPwdBsnl, payload);
      const { returnCode, returnMsg } = getRequestData(response);
      if (returnCode === '0') {
        yield put({
          type: 'forgotTiming',
        });
        yield put({
          type: 'save',
          payload: { forgotSendTime: Date.now() },
        });
        return true;
      }
      if (returnMsg && returnCode !== '0') {
        message.warning(i18n('LOGIN_SENDING_FAILED'));
      }
      return false;
    },

    *forgotTiming(_, { put, select, cancel }) { // 验证码的倒计时
      let times = yield select(state => state.business.DRM_BSNL_CAPTCHA_EXPIRE_CONFIG || 60);
      yield put({
        type: 'save',
        payload: { forgotTiming: true, forgotTimes: times },
      });
      for (; times >= 0; times -= 1) {
        const timing = yield select(state => state.bsnlLogin.forgotTiming);
        if (!timing) { // 如果循环还未完成，timing就被置为false了，说明当前循环需要跳出,同时取消当前的这个任务
          yield cancel();
          break;
        }
        yield put({
          type: 'save',
          payload: { forgotTimes: times },
        });
        yield delay(1000);
      }
      yield put({
        type: 'save',
        payload: { forgotTiming: false, forgotTimes: times },
      });
    },

    *qryCurrentSecurityRule({ payload }, { call, put }) {
      const { success, data } = yield call(qryCurrentSecurityRule);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            securityRule: data,
            resetModal: true,
            userMsg: payload,
          },
        });
      }
    },

    *qryAllowMultipleTabPage(_, { call, put }) {
      const { success, data } = yield call(qryAllowMultipleTabPage);
      if (success) {
        if (data.toUpperCase() === 'N') {
          // 返回N或n，表示不允许浏览器打开两个tabs
          const pageCookieKey = 'dscm_web_index';
          const pageIndex = getCookie(pageCookieKey) || '1';
          if (+pageIndex > 1) {
            failAlert({
              title: i18n('NO_MULTIPLE_TAB_PAGES'),
              content: '',
            });
            yield put({
              type: 'save',
              payload: {
                lockOpen: true,
              },
            });
          }
          setCookie(pageCookieKey, `${+pageIndex + 1}`);
          window.addEventListener('unload', () => {
            if (getCookie(pageCookieKey) !== '1' && +getCookie(pageCookieKey) >= 2) {
              setCookie(pageCookieKey, `${+getCookie(pageCookieKey) - 1}`);
            }
          });
        }
      }
    },

    *genCaptcha(_, { call, put }) {
      const response = yield call(genCaptcha);
      const { imgCode, imgToken } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          imgReturn: {
            imgCode,
            imgToken,
          },
        },
      });
    },

    *doForgetPwdBsnl({ payload }, { call, put }) {
      const response = yield call(doForgetPwdBsnl, payload);
      const { returnMsg = '', returnCode = '' } = getRequestData(response);
      if (`${returnCode}` === '0') {
        message.success(i18n('LOGIN_SUCCESS_TO_MODIFY_PASSWORD'));
        yield put({
          type: 'save',
          payload: {
            forgotModal: false,
          },
        });
      } else if (returnMsg) {
        // 展示后台报错
        message.warning(returnMsg);
      }
    },

    *logout(_, { call, put }) {
      const res = yield call(logout);
      yield put({
        type: 'changeLoginStatus',
        payload: {
          status: false,
        },
      });
      yield put({
        type: 'dxpGlobal/updateState',
        payload: {
          currentUser: {},
        },
      });
      // Fishx.history.push('/userLogin');
      window.location.reload();
      return res;
    },
    *getSessionTime(_, { call }) {
      const { data: noticeTime } = yield call(getNoticeTime);
      const { data: interval } = yield call(getInterval);
      return { noticeTime, interval };
    },
    *getSessionRemineTime(_, { call }) {
      const { data } = yield call(getRemainingTime);
      return Number(data);
    },
    *refreshSessionTime(_, { call }) {
      yield call(recoverSession);
    },
  },

  reducers: {
    changeLoginStatus(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
